import { SeatInfoCombinedProps } from './types';

const usePresenter = (props: SeatInfoCombinedProps): SeatInfoCombinedProps => {
  return props;
};

export default usePresenter;
